import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { DataServiceService } from '../data-service.service';
import { HttpClient } from '@angular/common/http';
import { getSourceByField, SourceItem } from '../utils/source-utils';
import { goBackToHistory } from '../utils/history-navigation-utils';

@Component({
  selector: 'app-result-criminal',
  templateUrl: './result-criminal.component.html',
  styleUrls: ['./result-criminal.component.scss']
})
export class ResultCriminalComponent implements OnInit {

  chinese_string = ""
  isChineseSearch = localStorage.getItem("isChineseSearch");
  isChineseSearchBoolean: boolean;
  showSuccessMsg: boolean = false;
  isSavingRecord: boolean = false
  individualData = JSON.parse(localStorage.getItem('data'))
  sourceInfo: SourceItem | null = null;

  constructor(
    private dataService: DataServiceService,
    private router: Router,
    private authService: AuthService,
    private http: HttpClient,
    private location: Location
  ) { }

  goBack() {
    if (sessionStorage.getItem("historyDetailFromHistory") === "true") {
      goBackToHistory(this.location);
      return;
    }
    localStorage.setItem("skipSearchOnBack", "true");
    localStorage.setItem("skipSearchOnBackTs", Date.now().toString());
    this.location.back();
  }

  ngOnInit(): void {
    console.log(this.individualData)
    if(this.isChineseSearch == "true"){
      this.isChineseSearchBoolean = true;
      this.chinese_string = localStorage.getItem('chinese_string')
    }else{
      this.isChineseSearchBoolean = false;
    }

    // Load source information if available
    if (this.individualData && this.individualData.source_id) {
      this.loadSourceInfo(this.individualData.source_id);
    }
  }

  /**
   * Load source information from list_sources.json
   */
  async loadSourceInfo(sourceId: string): Promise<void> {
    try {
      this.sourceInfo = await getSourceByField(sourceId, this.http);
      console.log('Source info loaded:', this.sourceInfo);
    } catch (error) {
      console.error('Error loading source info:', error);
    }
  }

  saveRecord(){
    this.isSavingRecord = true
    var currentDate = new Date()

    var historyObj = {}

    historyObj['userEmail'] = this.authService.getCurrentUser().email;
    
    this.individualData['saveDate'] = `${currentDate.getDate()}/${currentDate.getMonth()+1}/${currentDate.getFullYear()}`;
    this.individualData['saveTime'] = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    this.individualData['UTCsaveDate'] = `${currentDate.getUTCDate()}/${currentDate.getUTCMonth()+1}/${currentDate.getUTCFullYear()}`;
    this.individualData['UTCsaveTime'] = `${currentDate.getUTCHours()}:${currentDate.getUTCMinutes()}:${currentDate.getUTCSeconds()}`;
    this.individualData['type'] = 'CRIMINALS'
    
    historyObj['historyData'] = [this.individualData]

    this.dataService.saveSearchResult(historyObj)
    .then((data)=>{
      if(data['msg'] == 'Saved record'){
        this.isSavingRecord = false
        this.showSuccessMsg = true;
        setTimeout(() => {
          this.showSuccessMsg = false;
        }, 5000);
      }
      else{
        alert('Failed to save record. Please try after some time')
      }
    })
  }

}
